import { makeStyles } from "@material-ui/core/styles";

export default makeStyles((theme) => {
  return {
    wrapperFiltersSections: {
      display: "flex",
      flexDirection: "row",
      gap: "12px",
      flexWrap:'wrap'
    },
    wrapperInput: {
      width: "190px",
    },
  };
});
